/**
 * Author(s) : Karthik
 * Purpose : This is image card with name and designation.It can be used on speakers/guests/users gallery.
 */
import React from 'react';
import styles from './ImageCard.module.scss';
import PropTypes from 'prop-types';

const Image = (props) => {
  // Image properties will be passed through props
  const { imageURL, name, designation = null } = props;
 
  const img = require(`../../assets/images/${imageURL}`);
  
  
  return (
    <div className={styles.imgCard}>
      <div className={styles.imgContainer}>
        <img className={styles.profilePhoto} src={img} alt={name} />
        <div className={styles.imgTextContainer}>
          <div className={styles.name}>{name}</div>
          {designation && (
            <div className={styles.designation}>{designation}</div>
          )}
        </div>
      </div>
      <div className={styles.gradient}></div>
    </div>
  );
};

export default Image;

//Proptypes for imageCard component
Image.propTypes = {
  imageURL: PropTypes.string,
  name: PropTypes.string,
  designation: PropTypes.string,
};
